import { Gamepad2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useMode } from '@/hooks/useMode';
import { cn } from '@/lib/utils';

export function GamerToggle() {
  const { mode, toggle } = useMode();
  const active = mode === 'gamer';
  const label = active ? 'Voltar ao modo tradicional' : 'Ativar modo gamer';

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={() => toggle('gamer')}
      aria-label={label}
      title={label}
      aria-pressed={active}
      className="rounded-full backdrop-blur"
    >
      <Gamepad2
        className={cn('h-4 w-4 transition-opacity', active ? 'opacity-100' : 'opacity-40')}
      />
    </Button>
  );
}
